<template>
  <div class="timer-wrapper">
    <div class="text-center">
      <h2 class="msg">Next workshop in</h2>
      <span>
       <span class="time-bold">{{ days }}</span> <span class="light-text" v-if="days>1">Days:</span><span
          class="light-text" v-else>Day:</span>
      </span>
      <span>
       <span class="time-bold"> {{ hours | formatTime }}</span> <span class="light-text" v-if="hours>1">Hrs:</span><span
          class="light-text" v-else>Hr:</span>
      </span>
      <span>
     <span class="time-bold"> {{ minutes | formatTime }}</span> <span class="light-text"
                                                                      v-if="minutes>1">Mins</span><span
          class="light-text" v-else>Min</span>
      </span>
      <span class="time-bold"> {{ seconds | formatTime }}</span>
      <span class="light-text"
            v-if="minutes>1">Secs</span><span
        class="light-text" v-else>Sec</span>

    </div>
    <div class="center-btn">
      <button class="work-btn">View Workshop</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "trainerTimer",
  props: {
    time: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentTime: Date.parse(this.eventTime) - Date.parse(new Date())
    };
  },
  mounted() {
    setTimeout(this.countdown, 1000);
  },
  computed: {
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    }
  },
  filters: {
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    }
  },
  methods: {
    countdown() {
      this.currentTime = Date.parse(this.eventTime) - Date.parse(new Date());
      if (this.currentTime > 0) {
        setTimeout(this.countdown);
      } else {
        this.currentTime = null;
      }
    }
  },
  created() {
    this.eventTime = this.time
  }
};
</script>

<style scoped>
.timer-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 230px;
  background-color: #0B2A5A;
  color: whitesmoke;
  font-size: 2rem;
  font-family: "Montserrat";
}

.msg {
  font-size: 25px;
  color: #728391;
}

.light-text {
  opacity: 75%;
}

.time-bold {
  font-weight: bolder;
}

.center-btn {
  margin: 1em;
  display: flex;
  justify-content: center;
}

.work-btn {
  width: 300px;
  height: 40px;
  border: 1px solid #00f241;
  border-radius: 4px;
  background-color: transparent;
  color: #00f241;
  font-size: 20px;
}
</style>